// Screen `object-fields` — design/screens/ObjectBuilder.dc.html — owner: S4 (the field type picker
// opens as a modal here; S3's formula editor lives in src/features/formula/).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ObjectBuilderPage } from '../../../../../features/data-model/ObjectBuilderPage';
import { OBJECT_TABS } from '../../../../../features/data-model/object-tabs';

const Search = z.object({
  tab: z.enum(OBJECT_TABS).optional().catch(undefined),
  field: z.string().max(63).optional().catch(undefined),
});

export const Route = createFileRoute('/_settings/settings/objects/$key/')({
  validateSearch: (s) => Search.parse(s),
  component: ObjectBuilderRoute,
});

function ObjectBuilderRoute() {
  const { key } = Route.useParams();
  const search = Route.useSearch();
  return <ObjectBuilderPage key={key} objectKey={key} search={search} />;
}
